import { ReactElement } from 'react';
import type { FeatureName } from './feature-flag-context';
import useFeatureFlag from './use-feature-flag';

export type FeatureFlagProps = {
  feature: FeatureName;
  children: ReactElement;
  fallback?: ReactElement | null;
};

export function FeatureFlag({ feature, children, fallback = null }: FeatureFlagProps): ReactElement | null {
  const allowed = useFeatureFlag(feature);
  if (!allowed) {
    return fallback;
  }
  return children;
}
